import { Button, DatePicker, Form, Modal, message } from "antd";
import dayjs from "dayjs";
import React, { useState } from "react";
import { $t } from "~/i18n.js";
import { api } from "~/lib/api.js";

export const InvoiceDownloadModal = ({ open, onClose, userId = null }) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const handleDownload = async () => {
    try {
      setLoading(true);
      const values = await form.validateFields();
      const date_from = values.date_from.format("YYYY-MM-DD");
      const date_to = values.date_to.format("YYYY-MM-DD");

      let url = `financial/accounts/create_invoice.json?date_from=${date_from}&date_to=${date_to}`;
      if (userId) url += `&user_id=${userId}`;
      const fileName = `${$t("kosten overzicht")}_${date_from}_${date_to}.pdf`;

      await api.open_file(url, fileName);
      onClose();
    } catch (e) {
      message.error($t("Selecteer een geldige periode."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      title={$t("Kosten overzicht downloaden")}
      footer={null}
      destroyOnClose
    >
      <Form
        form={form}
        layout="horizontal"
        initialValues={{
          date_from: dayjs().startOf("year"),
          date_to: dayjs(),
        }}
        requiredMark={false}
      >
        <Form.Item
          name="date_from"
          label={$t("Van")}
          rules={[{ required: true }]}
        >
          <DatePicker format="DD-MM-YYYY" style={{ width: "100%" }} />
        </Form.Item>
        <Form.Item
          name="date_to"
          label={$t("Tot en met")}
          rules={[{ required: true }]}
        >
          <DatePicker format="DD-MM-YYYY" style={{ width: "100%" }} />
        </Form.Item>
        <Button
          type="primary"
          loading={loading}
          onClick={handleDownload}
          style={{ width: "100%" }}
        >
          {$t("Download PDF")}
        </Button>
      </Form>
    </Modal>
  );
};
